import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';
import { nameResolver } from '@/_shared';

import { useGetContactsMutation } from '../apis';
import type { ContactQueryLinkerSchema } from '../schemas';

export function AsyncContactSelector({ disabled, ...props }: FormAsyncComboboxProps<ContactQueryLinkerSchema>) {
  const getName = useCallback(
    (item: ContactQueryLinkerSchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName = nameResolver(item.first_name, item.last_name, '');

      if (!disabled) {
        return itemName;
      }

      return (
        <PrimaryLink to="/contacts/$id" params={{ id: `${item.id}` }} state={{ naturalBack: true }}>
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={getName}
      keyExtractor={(item) => `${item.id}`}
      useApi={useGetContactsMutation}
      disabled={disabled}
    />
  );
}
